<div class="upload-section" (click)="inputFile.click()">
    <div class="cloud"></div>
    <h3>{{ 'inobyd_file_upload' | localise }}</h3>

    <input
            class="file"
            #inputFile
            type="file"
            (change)="handleFileInput($event)"
    />
</div>
